// The Mobility Layer lists and pins every non-shelter category by default. Each category
// pill can switch one of them off; the `category` search param then names the ones still
// on. Returns null when nothing is switched off, meaning "no category filter".
export const categoryParam = (allCategories, hiddenCategories) => {
  if (hiddenCategories.size === 0) return null
  return allCategories.filter((category) => !hiddenCategories.has(category)).join(',')
}
